/**
 * @file formUploadFieldes
 * 写真登録画面 項目名
 */

import * as FormUploadOptionConstants from '@/js/util/member/formUploadOptionConstants'

/**
 * 写真登録画面の情報
 * @param {string} category 申込種別 (credit or installment)
 * @param {object} formState
 * @param {string} registration 申込み時のステータス (new, add, change)
 */

export const FormUploadFieldes = (category, formState, registration) => {
  return {
    // 口座名義人
    bankAccountHolder: {
      key: 'bank_account_holder',
      name: '口座名義人',
      required: true,
      isShow: true,
      choices:
        category === 'credit'
          ? FormUploadOptionConstants.CreditBankAccountHolder
          : FormUploadOptionConstants.InstallmentBankAccountHolder
    },
    // 口座名義人名
    bankAccountHolderName: {
      key: 'bank_account_holder_name',
      name: '口座名義人名(カナ)',
      required: true,
      isShow: true
    },
    // 口座登録
    bankAccountRegistration: {
      key: 'bank_account_registration',
      name: '口座登録',
      required: true,
      isShow: true,
      choices: FormUploadOptionConstants.BankAccountRegistration
    },
    bankAccountRegistrationDate: {
      key: 'bank_account_registration_date',
      name: 'A済 日付',
      placeholder: '',
      required: formState.bank_account_registration === 'A済',
      isShow: formState.bank_account_registration === 'A済'
    },
    // 本人確認電話フラグ
    isBeri: {
      key: 'is_beri',
      name: '本人確認電話',
      required: true,
      isShow: category === 'credit' && formState.is_beri
    },
    // 確認日時
    beriTiming: {
      key: 'beri_timing',
      name: '確認日時',
      required: true,
      isShow: category === 'credit' && formState.is_beri,
      choices: FormUploadOptionConstants.BeriTiming
    },
    // ベリ指定日時
    beriAt: {
      key: 'beri_at',
      name: '指定日時',
      required: true,
      placeholder: '',
      isShow: category === 'credit' && formState.is_beri && formState.beri_timing === '指定日時選択',
      beriAtBusinessDays: FormUploadOptionConstants.beriAtBusinessDays,
      beriAtHolidays: FormUploadOptionConstants.beriAtHolidays
    }
  }
}
